import { useTheme } from '@sds-system/system';
import type { ColorCode } from '@sds-system/types';
import { getColorValue } from '@sds-system/utils';
import { getSpinnerId } from './Spinner.const';
import type { SpinnerProps } from './Spinner.types';

export const SpinnerDot = ({ color, activeColor, variant, name, ...props }: SpinnerProps) => {
  const theme = useTheme();
  const { palette } = theme;

  const svgColor = getColorValue((color || palette.primary[100]) as ColorCode, theme);
  const svgActiveColor = getColorValue(
    (activeColor || palette.bg.interactive.primary) as ColorCode,
    theme,
  );

  const animateIdList = getSpinnerId(8, variant, name);

  return (
    <svg
      fill='none'
      height='48'
      viewBox='0 0 48 48'
      width='48'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='4' cy='24' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[0]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[0]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='44' cy='24' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[4]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[4]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='24' cy='4' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[2]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[2]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='24' cy='44' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[6]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[6]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='38.1421' cy='9.85784' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[3]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[3]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='9.85779' cy='38.1421' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[7]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[7]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='38.1421' cy='38.1421' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[5]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[5]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
      <circle cx='9.85779' cy='9.85785' fill={svgColor} r='4'>
        <animate
          attributeName='fill'
          begin={animateIdList[1]?.begin}
          dur='0.1'
          from={svgColor}
          id={animateIdList[1]?.id}
          to={svgActiveColor}
        ></animate>
      </circle>
    </svg>
  );
};
